"use client";

import { ClientFormatMoneyPriceWrapperProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/PriceText/ClientFormatMoneyPriceWrapperProps";
import { useNationality } from "@faire/retailer-visitor-shared/hooks/retailer/useNationality";
import { useIsLoggedInRetailerOrBrandPreview } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { Price } from "@faire/retailer-visitor-shared/views/product/ProductDetails/Price/Price";
import { IPriceTextProps } from "@faire/retailer-visitor-shared/views/product/ProductDetails/Price/PriceProps";
import { formatMoney } from "@faire/web--source/common/money";
import omit from "lodash/omit";
import React from "react";

export const PriceWithClientFormatMoney: React.FC<
  ClientFormatMoneyPriceWrapperProps & {
    shouldHidePriceProminencePriceTestV3?: boolean;
  }
> = (props) => {
  const { isUK: isUKRetailer } = useNationality();
  const isLoggedInOrBrandPreview = useIsLoggedInRetailerOrBrandPreview();

  const { shouldHidePriceProminencePriceTestV3 } = props;
  if (shouldHidePriceProminencePriceTestV3) {
    return null;
  }
  const originalPrice = props.min_option_wholesale_price
    ? formatMoney({
        money: props.min_option_wholesale_price,
        omitCentsIfZero: true,
      })
    : "";

  const wholesalePrice = props.min_option_wholesale_promo_price
    ?.discounted_item_price
    ? formatMoney({
        money: props.min_option_wholesale_promo_price.discounted_item_price,
        omitCentsIfZero: true,
      })
    : originalPrice;

  const retailPrice = props.min_option_retail_price
    ? formatMoney({
        money: props.min_option_retail_price,
        omitCentsIfZero: true,
      })
    : "";
  const clientPriceProps: IPriceTextProps = {
    ...omit(props, [
      "min_option_retail_price",
      "min_option_wholesale_promo_price",
      "min_option_retail_price",
    ]),
    originalPrice,
    wholesalePrice,
    retailPrice,
    isUKRetailer,
    isLoggedInOrBrandPreview,
  };

  return <Price {...clientPriceProps} />;
};
